import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/denoncer.svg'
import _imports_1 from '../assets/images/follow.svg'


const _withScopeId = n => (_pushScopeId("data-v-15e68cfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_header" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-header" }, [
  /*#__PURE__*/_createTextVNode(" Plateforme des "),
  /*#__PURE__*/_createElementVNode("span", { class: "header-text" }, "plaintes et dénonciations"),
  /*#__PURE__*/_createTextVNode(" des actes de corruption et de mauvaise gouvernance ")
], -1))
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = { class: "denoncer" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "action-img",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"white"} }, "Dénoncer", -1))
const _hoisted_8 = { class: "follow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "action-img",
  src: _imports_1,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"white"} }, "Suivre ma dénonciation", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "copytext" }, [
  /*#__PURE__*/_createTextVNode(" © 2022 Cellule d’analyse et de traitement des plaintes "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" et dénonciations des faits de corruption ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderPage = _resolveComponent("HeaderPage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderPage),
      _hoisted_3,
      _createElementVNode("footer", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_router_link, { to: "/report" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_router_link, { to: "/follow" }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _hoisted_11
      ])
    ])
  ]))
}